<template>
  <div class="greeting-container" v-show="greeting.message">
    <img
      class="avatar"
      :src="getAvatar"
      alt=""
    />
    <div class="content">
      <div class="name">
        <span class="kfName">{{kfName}}</span>
        <span class="kfTag">{{kfTag}}</span>
      </div>
      <p class="message">{{message}}</p>
    </div>
  </div>
</template>

<script>
import setPicSize from '@zz-app/setPicSize'
export default {
  props: {
    greeting: {
      type: Object
    }
  },
  computed: {
    kfName() {
      return this.greeting.name || '转小多'
    },
    kfTag() {
      return this.greeting.msgTag || '智能助理'
    },
    getAvatar() {
      return setPicSize(this.greeting.avatarUrl, 200, 200)
    },
    message() {
      return this.greeting.message || ''
    }
  }
}
</script>
<style lang="less" scoped>
  @import './index.less';
</style>